import { createContext, useContext, useEffect, useId } from 'react';

export const DirtyContext = createContext<(id: string, dirty: boolean) => void>(() => {});
export function useDraftGuard(dirty: boolean) {
  const id = useId();
  const report = useContext(DirtyContext);
  useEffect(() => { report(id, dirty); return () => report(id, false); }, [id, dirty, report]);
}
